import { useTranslation } from 'react-i18next';
import { Phone, User } from 'lucide-react';
import { DriverItem } from '@/types';

interface DriverInfoProps {
  assign?: boolean;
  driver?: DriverItem | null;
}

const DriverInfo = ({ assign = false, driver }: DriverInfoProps) => {
  const { t } = useTranslation();

  if (!assign || !driver) {
    return (
      <div className='flex items-center gap-3 py-2'>
        <div className='w-10 h-10 rounded-full bg-[rgb(245,245,243)] flex items-center justify-center'>
          <User size={18} className='text-[rgb(115,123,140)]' />
        </div>
        <span className='text-sm text-[rgb(115,123,140)]'>
          {String(t('order_assign', { defaultValue: 'The order will be assigned to a driver when scheduled.' }))}
        </span>
      </div>
    );
  }

  const driverName = `${driver.first_name || '—'} ${driver.last_name || ''}`.trim();
  const initials = `${(driver.first_name ?? '')[0] || ''}${(driver.last_name ?? '')[0] || ''}`.toUpperCase();

  return (
    <div className='flex items-center justify-between'>
      <div className='flex items-center gap-3'>
        {/* Avatar */}
        <div className='w-10 h-10 rounded-full bg-[rgb(245,245,243)] flex items-center justify-center shrink-0'>
          <span className='text-[13px] font-semibold text-[rgb(57,57,60)]'>{initials || '?'}</span>
        </div>

        {/* Name + Phone */}
        <div className='flex flex-col gap-0.5'>
          <span className='text-[14px] font-semibold text-[rgb(57,57,60)]'>{driverName}</span>
          {driver.phone && (
            <span className='text-[12px] text-[rgb(115,123,140)]' dir='ltr'>{driver.phone}</span>
          )}
        </div>
      </div>

      {/* WhatsApp/Call button */}
      {driver.phone && (
        <a
          href={`https://wa.me/${driver.phone}`}
          target='_blank'
          rel='noopener noreferrer'
          className='w-9 h-9 rounded-full bg-[rgb(237,224,74)] flex items-center justify-center shrink-0 hover:bg-[rgb(230,217,60)] transition-colors'
        >
          <Phone size={16} className='text-[rgb(57,57,60)]' />
        </a>
      )}
    </div>
  );
};

export default DriverInfo;
